export default __webpack_public_path__ + "static/media/img_assessment_history_empty.824216bc.png";